<!--
 * @Author: zhangcx33595
 * @Date: 2021-05-31 16:43:45
 * @LastEditors: zhangcx33595
 * @LastEditTime: 2021-06-15 12:44:27
 * @FilePath: \openplat-web\src\gtn\components\photonTip.vue
-->

<template>
  <div id="photon-wrapper">
    <div id="photon-box">
      <img />
      <p>光子+{{number}}</p>
      <i class="photo_bg" />
    </div>
  </div>
</template>
<script>
import { Parabola } from '@/utils/parabola'
export default {
  name: 'PhotonTip',
  data () {
    return {
      timer: null
    }
  },
  computed: {
    number () {
      let n = localStorage.getItem('photon_num')
      return n &&n !=''&& parseInt(n) ? n : 0
    }
  },
  mounted () {
    let el = document.querySelector('#photon-box')
    el.style.transform = 'scale(1.2)'
    // el.style.top = '46%'
    el.style.transition = 'all 1s'
    // this.timer = setTimeout(() => {
    //   // this.eleDown()
    // }, 2000);
  },
  methods: {
    // 元素移入
    eleDown () {
      let _this = this
      const parabola = new Parabola({
        origin: '#photon-wrapper', target: '#gtn-gj-id', element: '#photon-wrapper', radian: 0.0004, time: 200, callback: () => {
          let org = document.querySelector('#photon-wrapper')
          org.style.display = 'none'
          clearTimeout(_this.timer)
        }
      })

      parabola.move()
    }
  },
}
</script>
<style lang="scss" scoped>
#photon-wrapper {
  position: absolute;
  left: 42%;
  top: 42%;
  width: 200px;
  height: 100px;
  text-align: center;
  #photon-box {
    transform: scale(0);
    transition: all 0.5;
    img {
      height: 56px;
      animation: bounce 1.6s 0.2s ease both;
      content: url('~@/assets/index/photon3x.png');
      z-index: 100;
      position: absolute;
      left: 76px;
      top: 14px;
    }
    p {
      font-size: 16px;
      color: #d9534f;
      letter-spacing: 0;
      font-weight: 600;
      position: absolute;
      top: 84px;
      z-index: 99;
      width: 100%;
    }

    .photo_bg {
      position: absolute;
      display: inline-block;
      width: 200px;
      height: 200px;
      background: url('~@/assets/index/guang.png') no-repeat center center;
      animation: rotation 20s linear infinite;
      /*border-radius: 150px;*/
      background-size: 182px;
      overflow: hidden;
      z-index: 98;
      left: 0px;
      top: -38px;
    }
  }
}
@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-40px);
  }
  60% {
    transform: translateY(-15px);
  }
}
</style>




// WEBPACK FOOTER //
// src/gtn/components/photonTip.vue